import { Api } from '../modules/Service';

const MSupplier = {
  list: () => {
    return Api('/supplier/list');
  },
  add: data => {
    return Api('/supplier/new', JSON.stringify(data), 'POST', 'text');
  },
  update: data => {
    return Api(
      '/supplier/set/' + data.id,
      JSON.stringify(data),
      'POST',
      'text',
    );
  },
  delete: id => {
    return Api('/supplier/del/' + id, {}, 'GET', 'text');
  },
  get: id => {
    return Api('/supplier/get/' + id);
  },
};
export default MSupplier;
